module.exports = __webpack_public_path__ + "static/media/Droogwaren.82fe7314.svg";